import { Mic, MicOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface MicButtonProps {
  isRecording: boolean;
  isSupported: boolean;
  disabled?: boolean;
  onClick: () => void;
  size?: "sm" | "md";
  title?: string;
}

export function MicButton({
  isRecording,
  isSupported,
  disabled,
  onClick,
  size = "md",
  title,
}: MicButtonProps) {
  if (!isSupported) {
    return (
      <Button
        size="icon"
        variant="ghost"
        disabled
        className={cn(
          size === "sm" ? "h-8 w-8" : "h-9 w-9",
          "rounded-full text-slate-300 shrink-0",
        )}
        title="Voice input not supported on this device"
      >
        <MicOff className={size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4"} />
      </Button>
    );
  }

  return (
    <Button
      size="icon"
      variant="ghost"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        size === "sm" ? "h-8 w-8" : "h-9 w-9",
        "rounded-full shrink-0 transition-colors",
        isRecording
          ? "bg-[#8B1A1A] hover:bg-[#631212] text-white animate-pulse"
          : "text-slate-500 hover:text-[#8B1A1A] hover:bg-[#8B1A1A]/10",
      )}
      title={title || (isRecording ? "Stop recording" : "Voice input")}
    >
      <Mic className={size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4"} />
    </Button>
  );
}
